import React from 'react';
import { Box, Typography, Grid, Paper, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ParentDashboard: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <Box sx={{ p: { xs: 2, md: 4 } }}>
      <Typography variant="h4" sx={{ mb: 3 }}>
        Parent Portal
      </Typography>

      <Paper sx={{ p: 3, mb: 4 }}>
        <Typography variant="h6" sx={{ mb: 1 }}>
          Guardian Information
        </Typography>
        <Typography variant="body1">Name: {user?.parentName || user?.name || 'N/A'}</Typography>
        <Typography variant="body1">Phone: {user?.parentPhone || 'N/A'}</Typography>
        <Typography variant="body1">Email: {user?.parentEmail || user?.email || 'N/A'}</Typography>
        <Typography variant="body1">Student: {user?.registrationId || user?.name || 'N/A'}</Typography>
        <Typography variant="body1">Class: {user?.className || 'N/A'}</Typography>
      </Paper>

      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 3, height: '100%' }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              View Student Status
            </Typography>
            {user?.reportCardPublished && (
              <Button fullWidth variant="contained" sx={{ mb: 1 }} onClick={() => navigate('/parent/report-card')}>
                View report card
              </Button>
            )}
            <Button fullWidth variant="outlined" onClick={() => navigate('/school-work/attendance')}>
              Attendance overview
            </Button>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 3, height: '100%' }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              Parent Support
            </Typography>
            <Button fullWidth variant="contained" sx={{ mb: 1 }} onClick={() => navigate('/parent/tickets')}>
              Submit a ticket
            </Button>
            <Button fullWidth variant="outlined" onClick={() => navigate('/school-work/term-history')}>
              Term history
            </Button>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 3, height: '100%' }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              School Payments
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              View school fee and extracurricular activity payment instructions for your child.
            </Typography>
            <Button fullWidth variant="contained" onClick={() => navigate('/parent/payments')}>
              Pay school fees
            </Button>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ParentDashboard;
